// extracted by mini-css-extract-plugin
export default {"company-benefit-group":"CompanyBenefitGroup_company-benefit-group__FnKrF"};